import { Link } from 'react-router-dom';
import { MarketingLandingShell } from '../components/marketing/MarketingLandingShell';
import { PageSeo } from '../components/seo/PageSeo';
import { SignUpButton, TalkToFoundersButton } from '../components/CTAButtons';
import { NOT_FOUND_META } from '../lib/seo';

const LINKS = [
  { to: '/', label: 'Home' },
  { to: '/product/script-editor', label: 'Product' },
  { to: '/blog', label: 'Blog' },
] as const;

export function NotFoundPage() {
  return (
    <>
      <PageSeo meta={NOT_FOUND_META} />
      <MarketingLandingShell>
        <section className="section band-dark min-h-[70vh] flex items-center">
          <div className="container max-w-[720px]">
            <p className="font-mono text-[11px] tracking-[0.22em] uppercase text-primary mb-4">
              404
            </p>
            <h1 className="font-headline font-medium text-[clamp(40px,5vw,72px)] leading-[0.95] tracking-[-0.03em] text-[#f2efea] m-0 mb-6">
              This shot isn’t on the timeline.
            </h1>
            <p className="text-[18px] text-on-surface leading-[1.55] opacity-80 m-0 mb-10 max-w-[52ch]">
              That URL doesn’t exist. Jump back to the home page, the product, or the blog.
            </p>
            <div className="flex flex-wrap gap-3 mb-10">
              {LINKS.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className="font-mono text-[11px] tracking-[0.16em] uppercase text-on-surface border border-white/15 px-4 py-3 hover:text-primary hover:border-primary/50 transition-colors"
                >
                  {link.label}
                </Link>
              ))}
            </div>
            <div className="flex flex-wrap gap-3">
              <TalkToFoundersButton />
              <SignUpButton variant="ghost" />
            </div>
          </div>
        </section>
      </MarketingLandingShell>
    </>
  );
}
